import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgLike = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M21.921 10.518a2.3 2.3 0 0 0-.445-.858 2.25 2.25 0 0 0-.757-.594 2.4 2.4 0 0 0-.95-.238H14.07V5.227c0-.306-.067-.595-.184-.875a2.1 2.1 0 0 0-.505-.73 2.1 2.1 0 0 0-.748-.477 2.1 2.1 0 0 0-.84-.144 2.27 2.27 0 0 0-1.085.28c-.336.17-.613.442-.807.765L6.421 9.66H3.353c-.361 0-.697.145-.958.4a1.38 1.38 0 0 0-.395.968v7.73c0 .365.143.705.395.968.252.255.597.4.958.4h3.194l.992.5A3.5 3.5 0 0 0 9.103 21h9.464c.555 0 1.085-.204 1.505-.578.412-.373.68-.883.748-1.418l1.152-7.517q.075-.497-.05-.969M3.27 18.758l.025-7.798a.1.1 0 0 1 .068-.026h2.782v7.917h-2.79zm16.307.068a1.03 1.03 0 0 1-.336.637.98.98 0 0 1-.673.254H9.12c-.328.017-.698-.084-1.01-.237l-.705-.357v-8.647l3.564-5.76a.935.935 0 0 1 .84-.45.955.955 0 0 1 1 .96v4.239c0 .348.286.637.631.637h6.304c.143.009.286.043.42.102a.96.96 0 0 1 .337.272q.139.165.201.382.063.216.026.433z"
      />
    </svg>
  );
};
export default SvgLike;
